import { render } from "./CancelMandateSuccessful.vue?vue&type=template&id=c0d728b0&scoped=true"
import script from "./CancelMandateSuccessful.vue?vue&type=script&lang=js"
export * from "./CancelMandateSuccessful.vue?vue&type=script&lang=js"

import "./CancelMandateSuccessful.vue?vue&type=style&index=0&id=c0d728b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0d728b0"]])

export default __exports__